module.exports = __webpack_public_path__ + "media/images/flags/cm-a8ed82bb913f6580a5bc6cfb7da63347.svg";